<div class="paymentrun-container">
    <h2>When are payments issued?</h2>
    <form>
      <mat-radio-group class="radio-group" [(ngModel)]="selectedFrequency" name="frequency" (change)="onFrequencyChange()">
        <mat-radio-button value="WEEKLY">1x Payment Per Week</mat-radio-button>
        <mat-radio-button value="BIWEEKLY">Payment Every Two Weeks</mat-radio-button>
        <mat-radio-button value="SEMIMONTHLY">Payment Twice Per Month</mat-radio-button>
        <mat-radio-button value="MONTHLY">Payment Once Per Month</mat-radio-button>
        <mat-radio-button value="CUSTOM">Custom Payment Dates</mat-radio-button>
      </mat-radio-group>
  
      
      <div *ngIf="selectedFrequency === 'WEEKLY'" class="input-group">
        <mat-form-field appearance="fill">
          <mat-label>Which day?</mat-label>
          <mat-select [(ngModel)]="selectedWeekday" name="weekday">
            <mat-option *ngFor="let day of weekDays" [value]="day.value">{{ day.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      
      <div *ngIf="selectedFrequency === 'BIWEEKLY'" class="input-group">
        <mat-form-field appearance="fill">
          <mat-label>Which weekday?</mat-label>
          <mat-select [(ngModel)]="selectedBiweeklyWeekday" name="biweeklyWeekday">
            <mat-option *ngFor="let day of weekDays" [value]="day.value">{{ day.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>First payment date(Optional)</mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="biweeklyStartDate" name="biweeklyStartDate">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
  
     
      <div *ngIf="selectedFrequency === 'SEMIMONTHLY'" class="input-group">
        <mat-form-field appearance="fill">
          <mat-label>First payment day</mat-label>
          <mat-select [(ngModel)]="semiMonthlyDay1" name="semiMonthlyDay1">
            <mat-option *ngFor="let day of daysSemiMonthly" [value]="day">{{ day }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Second payment day</mat-label>
          <mat-select [(ngModel)]="semiMonthlyDay2" name="semiMonthlyDay2">
            <mat-option *ngFor="let day of daysSemiMonthly" [value]="day">{{ day }}</mat-option>
            <mat-option value="last">Last day of month</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      
      <div *ngIf="selectedFrequency === 'MONTHLY'" class="input-group">
        <mat-form-field appearance="fill">
          <mat-label>Which day of the month?</mat-label>
          <mat-select [(ngModel)]="monthlyDay" name="monthlyDay">
            <mat-option *ngFor="let day of daysInMonth" [value]="day">{{ day }}</mat-option>
            <mat-option value="last">Last day of month</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
     
      <div *ngIf="selectedFrequency === 'CUSTOM'" class="input-group">
        <mat-label>Choose the payment days (select one or more):</mat-label>
        <div class="custom-checkboxes">
          <mat-checkbox *ngFor="let day of daysInMonth"
            [(ngModel)]="selectedCustomDays[day]" [name]="'customDay' + day">
            {{ day }}
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="customLastDay" name="customLastDay">
            Last day of the month
          </mat-checkbox>
        </div>
      </div>
  
      
      <div *ngIf="summary" class="summary">
        <strong> Summary : </strong>
        <span>{{ summary }}</span>
      </div>
    </form>
    <div class="save-button-container">
      <button
      class="gts-btn-primary"
      matRipple
        style="font-size:smaller;"
        (click)="SubmitNewConfig()"
        [disabled]="!isConfigValid"
        >
      <span class="gts-btn-text"> Save </span>
     
      </button>
    </div>
  </div>
  